exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-header[data-v-066d899e]{border-bottom:1px solid var(--border-primary)}.selected[data-v-066d899e]{color:var(--secondary);position:relative}.selected[data-v-066d899e]:after{content:\"\";position:absolute;height:3px;left:-12px;right:-12px;bottom:-16px;background-color:var(--secondary)}", ""]);

// exports
